"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledOverlay = exports.StyledLoader = exports.StyledBackground = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["className", "isLoading", "children", "styles"];
var defaultStyles = {
  loaderWidth: 10,
  loaderHeight: 10,
  loaderColor: 'black',
  backgroundBorderRadius: '0px',
  backgroundColor: 'rgba(255, 255, 255, 0.75)',
  zIndex: 0
};
var OverlayLoader = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
    isLoading = _ref.isLoading,
    children = _ref.children,
    styles = _ref.styles,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var extendedStyles = (0, _merge2["default"])(defaultStyles, styles);
  return /*#__PURE__*/_react["default"].createElement(StyledOverlay, (0, _extends2["default"])({}, props, {
    className: className,
    isLoading: isLoading
  }), children, isLoading && /*#__PURE__*/_react["default"].createElement(StyledBackground, {
    backgroundBorderRadius: extendedStyles.backgroundBorderRadius,
    backgroundColor: extendedStyles.backgroundColor,
    zIndex: extendedStyles.zIndex
  }, /*#__PURE__*/_react["default"].createElement(StyledLoader, {
    loaderWidth: extendedStyles.loaderWidth,
    loaderHeight: extendedStyles.loaderHeight,
    loaderColor: extendedStyles.loaderColor
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", null))));
});
OverlayLoader.displayName = 'OverlayLoader';
var StyledOverlay = exports.StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "OverlayLoader__StyledOverlay",
  componentId: "sc-a4wuq8-0"
})(["position:relative;"]);
var StyledBackground = exports.StyledBackground = _styledComponents["default"].div.withConfig({
  displayName: "OverlayLoader__StyledBackground",
  componentId: "sc-a4wuq8-1"
})(["position:absolute;display:flex;justify-content:center;align-items:center;top:0;background-color:", ";border-radius:", ";z-index:", ";width:100%;height:100%;"], function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, function (_ref3) {
  var backgroundBorderRadius = _ref3.backgroundBorderRadius;
  return backgroundBorderRadius;
}, function (_ref4) {
  var zIndex = _ref4.zIndex;
  return zIndex;
});
var StyledLoader = exports.StyledLoader = _styledComponents["default"].div.withConfig({
  displayName: "OverlayLoader__StyledLoader",
  componentId: "sc-a4wuq8-2"
})(["display:inline-block;position:relative;div{position:absolute;top:", "px;width:", "px;height:", "px;border-radius:50%;background:", ";animation-timing-function:cubic-bezier(0,1,1,0);&:nth-child(1){left:", "px;animation:lds-ellipsis1 0.6s infinite;}&:nth-child(2){left:", "px;animation:lds-ellipsis2 0.6s infinite;}&:nth-child(3){left:", "px;animation:lds-ellipsis2 0.6s infinite;}&:nth-child(4){left:", "px;animation:lds-ellipsis3 0.6s infinite;}@keyframes lds-ellipsis1{0%{transform:scale(0);}100%{transform:scale(1);}}@keyframes lds-ellipsis3{0%{transform:scale(1);}100%{transform:scale(0);}}@keyframes lds-ellipsis2{0%{transform:translate(0,0);}100%{transform:translate(", "px,0);}}"], function (_ref5) {
  var loaderHeight = _ref5.loaderHeight;
  return -(loaderHeight / 2);
}, function (_ref6) {
  var loaderWidth = _ref6.loaderWidth;
  return loaderWidth;
}, function (_ref7) {
  var loaderHeight = _ref7.loaderHeight;
  return loaderHeight;
}, function (_ref8) {
  var loaderColor = _ref8.loaderColor;
  return loaderColor;
}, function (_ref9) {
  var loaderWidth = _ref9.loaderWidth;
  return -loaderWidth * 2.4;
}, function (_ref10) {
  var loaderWidth = _ref10.loaderWidth;
  return -loaderWidth * 2.4;
}, function (_ref11) {
  var loaderWidth = _ref11.loaderWidth;
  return -loaderWidth / 1.5;
}, function (_ref12) {
  var loaderWidth = _ref12.loaderWidth;
  return -loaderWidth / 1.5;
}, function (_ref13) {
  var loaderWidth = _ref13.loaderWidth;
  return loaderWidth * 2;
});
OverlayLoader.propTypes = {
  className: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node.isRequired,
  styles: _propTypes["default"].objectOf({
    loaderWidth: _propTypes["default"].number,
    loaderHeight: _propTypes["default"].number,
    loaderColor: _propTypes["default"].string,
    backgroundBorderRadius: _propTypes["default"].string,
    backgroundColor: _propTypes["default"].string
  })
};
OverlayLoader.defaultProps = {
  className: '',
  styles: defaultStyles
};
var _default = exports["default"] = OverlayLoader;